/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import Start from '@/views/Start'
import Admin from '@/views/Admin'
import Analysis from '@/views/Analysis'
import Home from '@/views/Home'
import Router from 'vue-router'
import UserList from '@/components/user/UserList'
import Vue from 'vue'
import Statistiques from '@/components/user/Statistiques'
import Preferences from '@/components/user/Preferences'
import YaraRuleSetList from '@/components/yara/YaraRuleSetList'
import YaraRuleSet from '@/components/yara/YaraRuleSet'
import NewAnalysis from '@/components/analysis/NewAnalysis'
import AnalysisList from '@/components/analysis/AnalysisList'
import ForgotPassword from '@/components/user/ForgotPassword'
import Login from '@/components/user/Login'
import ChangePassword from '@/components/user/ChangePassword'
import Contact from '@/components/user/Contact'
import Faq from '@/components/user/Faq'
import Api from '@/components/user/Api'
import Nouveaute from '@/components/user/Nouveaute'
import AnalysisAll from '@/components/analysis/AnalysisAll'
import AnalysisSummary from '@/components/analysis/AnalysisSummary'
import AnalysisLogs from '@/components/analysis/AnalysisLogs'
import MessageBox from '@/components/shared/MessageBox'
import AnalysisManifest from '@/components/analysis/AnalysisManifest'
import AnalysisCode from '@/components/analysis/AnalysisCode'
import AnalysisInformation from '@/components/analysis/AnalysisInformation'
import AnalysisActivities from '@/components/analysis/AnalysisActivities'
import AnalysisBrowsableActivities from '@/components/analysis/AnalysisBrowsableActivities'
import AnalysisPermissions from '@/components/analysis/AnalysisPermissions'
import AnalysisVirus from '@/components/analysis/AnalysisVirus'
import AnalysisProviders from '@/components/analysis/AnalysisProviders'
import AnalysisReceivers from '@/components/analysis/AnalysisReceivers'
import AnalysisServices from '@/components/analysis/AnalysisServices'
import AnalysisAPI from '@/components/analysis/AnalysisAPI'
import AnalysisNetworkActivity from '@/components/analysis/AnalysisNetworkActivity'
import AnalysisSignatures from '@/components/analysis/AnalysisSignatures'
import AnalysisScreenshots from '@/components/analysis/AnalysisScreenshots'
import AnalysisSMSCalls from '@/components/analysis/AnalysisSMSCalls'
import AnalysisInteractiveSession from '@/components/analysis/AnalysisInteractiveSession'
import AnalysisRescan from '@/components/analysis/AnalysisRescan'
import AnalysisMemdumps from '@/components/analysis/AnalysisMemdumps'
import AnalysisHook from '@/components/analysis/AnalysisHook'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: Start,
            children: [
                {
                    name: 'login',
                    path: '',
                    component: Login,
                },
                {
                    name: 'forgotPassword',
                    path: 'forgotpassword',
                    component: ForgotPassword,
                },
                {
                    name: 'resetPassword',
                    path: 'changepassword/:token',
                    component: ChangePassword,
                },
            ],
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            children: [
                {
                    path: 'analysis',
                    name: 'analysislist',
                    component: AnalysisList,
                },
                {
                    path: 'analysis/new',
                    name: 'newanalysis',
                    component: NewAnalysis,
                },
                {
                    name: 'changePassword',
                    path: 'changepassword',
                    component: ChangePassword,
                },
                {
                    name: 'preferences',
                    path: 'preferences',
                    component: Preferences,
                },
                {
                    name: 'contact',
                    path: 'contact',
                    component: Contact,
                },
                {
                    name: 'faq',
                    path: 'faq',
                    component: Faq,
                },
                {
                    name: 'api',
                    path: 'api',
                    component: Api,
                },
                {
                    name: 'nouveaute',
                    path: 'nouveaute',
                    component: Nouveaute,
                },
            ],
        },
        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            children: [
                {
                    path: 'users',
                    component: UserList,
                },
                {
                    path: 'yararulesetlist',
                    name: 'yararulesetlist',
                    component: YaraRuleSetList,
                },
                {
                    path: 'yararuleset/:ruleSetId',
                    name: 'yararuleset',
                    component: YaraRuleSet,
                },
                {
                    path: 'yararuleset',
                    name: 'add_yararuleset',
                    component: YaraRuleSet,
                },
                {
                    path: 'statistiques',
                    name: 'statistiques',
                    component: Statistiques,
                },
            ],
        },
        {
            path: '/analysis/:analysisId',
            component: Analysis,
            children: [
                {
                    path: '/analysis/:analysisId/analysis',
                    name: 'analysis-all',
                    component: AnalysisAll,
                },
                {
                    path: '/analysis/:analysisId/summary',
                    name: 'analysis-summary',
                    component: AnalysisSummary,
                },
                {
                    path: '/analysis/:analysisId/manifest',
                    name: 'analysis-manifest',
                    component: AnalysisManifest,
                },
                {
                    path: '/analysis/:analysisId/code_analysis',
                    name: 'analysis-code',
                    component: AnalysisCode,
                },
                {
                    path: '/analysis/:analysisId/information',
                    name: 'analysis-information',
                    component: AnalysisInformation,
                },
                {
                    path: '/analysis/:analysisId/receivers',
                    name: 'analysis-receivers',
                    component: AnalysisReceivers,
                },
                {
                    path: '/analysis/:analysisId/providers',
                    name: 'analysis-providers',
                    component: AnalysisProviders,
                },
                {
                    path: '/analysis/:analysisId/services',
                    name: 'analysis-services',
                    component: AnalysisServices,
                },
                {
                    path: '/analysis/:analysisId/activities',
                    name: 'analysis-activities',
                    component: AnalysisActivities,
                },
                {
                    path: '/analysis/:analysisId/browsableactivities',
                    name: 'analysis-browsableactivities',
                    component: AnalysisBrowsableActivities,
                },
                {
                    path: '/analysis/:analysisId/permissions',
                    name: 'analysis-permissions',
                    component: AnalysisPermissions,
                },
                {
                    path: '/analysis/:analysisId/virus',
                    name: 'analysis-virus',
                    component: AnalysisVirus,
                },
                {
                    path: '/analysis/:analysisId/signatures',
                    name: 'analysis-signatures',
                    component: AnalysisSignatures,
                },
                {
                    path: '/analysis/:analysisId/api',
                    name: 'analysis-api',
                    component: AnalysisAPI,
                },
                {
                    path: '/analysis/:analysisId/logs',
                    name: 'analysis-logs',
                    component: AnalysisLogs,
                },
                {
                    path: '/analysis/:analysisId/network',
                    name: 'analysis-network',
                    component: AnalysisNetworkActivity,
                },
                {
                    path: '/analysis/:analysisId/smscall',
                    name: 'analysis-smscalls',
                    component: AnalysisSMSCalls,
                },
                {
                    path: '/analysis/:analysisId/screenshots',
                    name: 'analysis-screenshots',
                    component: AnalysisScreenshots,
                },
                {
                    path: '/analysis/:analysisId/memdumps',
                    name: 'analysis-memdumps',
                    component: AnalysisMemdumps,
                },
                {
                    path: '/analysis/:analysisId/hook',
                    name: 'analysis-hook',
                    component: AnalysisHook,
                },
                {
                    path: '/analysis/:analysisId/interactive-session',
                    name: 'analysis-interactive-session',
                    component: AnalysisInteractiveSession,
                },
                {
                    path: '/analysis/:analysisId/error',
                    name: 'analysis-error',
                    component: MessageBox,
                },
                {
                    name: 'yara-rescan',
                    path: '/analysis/:analysisId/rescan',
                    component: AnalysisRescan,
                },

            ],
        },
    ],
})
